import {
  EntitlementDetails,
  LinkedDestinationEntitlement,
  Promotion,
} from '@css-xp/graphtypes/src/generated-types-new';
import { OfferingName } from '@atlassian/cssxp-typescommon';
import { isFreePlanEntitlement, EntitlementEdition } from '@atlassian/cssxp-utils-entitlement';
import { isStatuspage } from '@atlassian/cssxp-utils-product';
import { FormState } from './manage-entitlement-v2';
import { isTrialEntitlement } from '../../../../entitlement-page-utility/entitlement-summary/entitlment-summary-utils';

export type PromotionInstanceDetail = Promotion & { promotionInstanceId?: string };

export const getDisabledFieldConfig = ({
  entitlement,
  isBillingCycleChanged,
  formState,
  isAnnualTermEnabled,
}: {
  entitlement: EntitlementDetails | LinkedDestinationEntitlement;
  isBillingCycleChanged: boolean;
  formState: FormState;
  isAnnualTermEnabled: boolean;
}) => {
  const isStatusPageProduct = isStatuspage(entitlement.productId);
  const shouldDisablePricingPlanAndOffering = isAnnualTermEnabled
    ? false
    : !isStatusPageProduct && isBillingCycleChanged && !isFreePlanEntitlement(entitlement);
  let config: any = {
    promotions: !!formState.hasOptedForUpgradeTrial,
    addPromotions: !!entitlement.upgradeTrial,
    offering: !!entitlement.upgradeTrial || shouldDisablePricingPlanAndOffering,
    units: !formState.offering?.label?.toLowerCase().includes(OfferingName.AUDIENCE_SPECIFIC.toLowerCase()),
    skipTrial: formState.skipTrialDisabled,
    userTier: !!entitlement.isApp,
    pricingPlan: shouldDisablePricingPlanAndOffering,
  };

  if (entitlement.isSandbox) {
    config = {
      promotions: true,
      offering: true,
      units: true,
      skipTrial: true,
      userTier: true,
      pricingPlan: true,
    };
  }

  return config;
};

export const isOptedForUpgradeTrial = ({
  entitlement,
  formState,
}: {
  entitlement: EntitlementDetails | LinkedDestinationEntitlement;
  formState: FormState;
}) => {
  const isStatusPageProduct = isStatuspage(entitlement?.productId);
  const isEntitlementOnTrial = isTrialEntitlement(entitlement, isStatusPageProduct);

  return (
    !isStatusPageProduct &&
    !entitlement.upgradeTrial &&
    entitlement.offering?.name?.toUpperCase() === EntitlementEdition.STANDARD &&
    !isEntitlementOnTrial &&
    formState.offering?.label?.toUpperCase() === EntitlementEdition.PREMIUM &&
    !formState.skipTrial
  );
};
